export default "__VITE_ASSET__fc39138e__"